import Marquee from "react-fast-marquee";

const ITEMS = [
  "More Reviews",
  "Google Visibility",
  "Customer Trust",
  "Social Proof",
  "AI Search Ready",
  "Automated Engagement",
  "Local Growth",
];

export default function BrandMarquee() {
  return (
    <div className="border-y border-black/10 bg-black py-5">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((item) => (
          <div key={item} className="flex items-center">
            <span className="px-8 text-sm font-bold uppercase tracking-[0.24em] text-white/85">
              {item}
            </span>
            <span className="text-white/30">✳</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
